var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-table',{ref:"table",staticClass:"j-table-force-nowrap",attrs:{"size":"middle","scroll":{x:true},"rowKey":"id","columns":_vm.columns,"pagination":false,"dataSource":_vm.dataSource}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }